export const JOB_ITEM_VARIANT_SEARCH = 'search'
export const JOB_ITEM_VARIANT_SAVED_JOBS = 'saved_jobs'